import { render } from "./Product360.vue?vue&type=template&id=3b2bfa9a&scoped=true"
import script from "./Product360.vue?vue&type=script&lang=js"
export * from "./Product360.vue?vue&type=script&lang=js"

import "./Product360.vue?vue&type=style&index=0&id=3b2bfa9a&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2bfa9a"]])

export default __exports__